import { render, staticRenderFns } from "./SelfList.vue?vue&type=template&id=3f4a47a1&scoped=true"
import script from "./SelfList.vue?vue&type=script&lang=js"
export * from "./SelfList.vue?vue&type=script&lang=js"
import style0 from "./SelfList.vue?vue&type=style&index=0&id=3f4a47a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a47a1",
  null
  
)

export default component.exports